function unhideIndexCategory(unTrigger,unContent,unClass) {
	var textIn = extraTrigger.attr("data-text-in");
	var textOut = extraTrigger.attr("data-text-out");
	unTrigger.on("click", function() {
		unContent.toggleClass(unClass)
		if (textIn && textOut) {
			(unContent.hasClass(unClass)) ? extraTrigger.text(textIn) : extraTrigger.text(textOut);
		}
	});
}